import { render, staticRenderFns } from "./SpendingManage.vue?vue&type=template&id=a95d4206&scoped=true&"
import script from "./SpendingManage.vue?vue&type=script&lang=js&"
export * from "./SpendingManage.vue?vue&type=script&lang=js&"
import style0 from "./SpendingManage.vue?vue&type=style&index=0&id=a95d4206&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95d4206",
  null
  
)

export default component.exports